export default __webpack_public_path__ + "static/media/paymentIconOne.407a9845.png";